const COMMENT_SITE_KEY = "6Lfi2ncbAAAAAM5HdzMrDNcSkFpmh0ARSsU81BRx";
// Czas otwarcia formularza opinii — do analizy czasu (bot wysyła natychmiast).
let commentFormOpenedAt = Date.now();
$(document).on("shown.bs.modal", '[id^="add_review_modal"]', function () {
    commentFormOpenedAt = Date.now();
});

const bind = function (model) {
    const buttons = $(model).find('[data-rating]');
    buttons.on('click', function () {
        const $this = $(this);
        $this.parent().find('[data-rating]').each(function (e, item) {
            const $item = $(item);
            if ($item.data('rating') <= $this.data('rating')) {
                $item.addClass('text-gold');
                $item.removeClass('text-gray');
            } else {
                $item.addClass('text-gray');
                $item.removeClass('text-gold');
            }
        });
        $this.siblings('input').val($this.data('rating'));
    });
    buttons.hover(function () {
        const $this = $(this);
        $this.parent().find('[data-rating]').each(function (e, item) {
            const $item = $(item);
            if ($item.data('rating') <= $this.data('rating')) {
                $item.addClass('text-gold');
                $item.removeClass('text-gray');
            } else {
                $item.addClass('text-gray');
                $item.removeClass('text-gold');
            }
        });
    });
    $('[data-rating-container]').on('mouseleave', function () {
        const $this = $(this);
        const inputVal = $this.find('input').val();
        $this.find('[data-rating]').each(function (e, item) {
            const $item = $(item);
            if ($item.data('rating') <= inputVal) {
                $item.addClass('text-gold');
                $item.removeClass('text-gray');
            } else {
                $item.addClass('text-gray');
                $item.removeClass('text-gold');
            }
        });
    });

    $('.add-comment-btn').on('click', function (e) {
        e.preventDefault();
        const form = $(this).closest('.modal').find('.add-comment-form');
        if (form.length === 0) {
            return;
        }
        form.find('input[name="elapsedTime"]').val(Date.now() - commentFormOpenedAt);

        if (typeof grecaptcha === 'undefined') {
            form.trigger('submit');
            return;
        }
        grecaptcha.ready(function () {
            grecaptcha.execute(COMMENT_SITE_KEY, { action: 'submit' }).then(function (token) {
                form.find('input[name="g-recaptcha-response"]').val(token);
                form.trigger('submit');
            });
        });
    });

}

export {
    bind,
}